import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { BRAND_NAME } from '../routes';
export default function AboutPage() {
    return /*#__PURE__*/ _jsxs("div", {
        className: "max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 py-16",
        children: [
            /*#__PURE__*/ _jsxs("h1", {
                className: "font-display text-5xl text-stone-900 uppercase tracking-wide mb-6",
                children: [
                    "About ",
                    BRAND_NAME
                ]
            }),
            /*#__PURE__*/ _jsx("p", {
                className: "text-stone-600 leading-relaxed text-lg",
                children: "A curated catalog of high-end smoking accessories — grinders, cases, and more. Every piece is built in-house, in small batches, with the materials and finish that obsessive users deserve. We ship each order ourselves."
            })
        ]
    });
}
